import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularStorageLock: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_storage-lock"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="storage-lock icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M10.75 13.75C11.4404 13.75 12 13.1904 12 12.5C12 11.8096 11.4404 11.25 10.75 11.25C10.0596 11.25 9.5 11.8096 9.5 12.5C9.5 13.1904 10.0596 13.75 10.75 13.75ZM7.25 5.5C7.25 3.567 8.817 2 10.75 2C12.683 2 14.25 3.567 14.25 5.5V6.5H15.25C16.4926 6.5 17.5 7.50736 17.5 8.75V16.25C17.5 17.4926 16.4926 18.5 15.25 18.5H6.25C5.00736 18.5 4 17.4926 4 16.25V8.75C4 7.50736 5.00736 6.5 6.25 6.5H7.25V5.5ZM12.75 5.5C12.75 4.39543 11.8546 3.5 10.75 3.5C9.64543 3.5 8.75 4.39543 8.75 5.5V6.5H12.75V5.5ZM5.5 8.75V16.25C5.5 16.6642 5.83579 17 6.25 17H15.25C15.6642 17 16 16.6642 16 16.25V8.75C16 8.33579 15.6642 8 15.25 8H6.25C5.83579 8 5.5 8.33579 5.5 8.75ZM9.7499 21C8.77024 21 7.93681 20.3739 7.62793 19.5H15.7499C17.2687 19.5 18.4999 18.2688 18.4999 16.75V10.1281C19.3738 10.4369 19.9999 11.2704 19.9999 12.25V16.75C19.9999 19.0972 18.0971 21 15.7499 21H9.7499Z" />
      </svg>
    </span>
  );
};

export { RegularStorageLock };
